import React from "react";

import defaultFieldRenderer from "./defaultFieldRenderer";
import type { FieldRenderers } from "./types";

type Props<DataType extends string> = {
  fieldValue: unknown;
  dataType: DataType;
  fieldRenderers?: FieldRenderers<DataType>;
  onCopySuccess?: () => void;
};

function FieldDisplay<DataType extends string>({
  fieldValue,
  dataType,
  fieldRenderers,
  onCopySuccess,
}: Props<DataType>) {
  const renderer =
    (fieldRenderers && fieldRenderers[dataType]) ?? defaultFieldRenderer;
  const { formattedText, tooltipText, node } = renderer(
    fieldValue,
    undefined,
    onCopySuccess,
  );
  return (
    <div>
      {node ??
        defaultFieldRenderer(formattedText, tooltipText, onCopySuccess).node}
    </div>
  );
}

export default React.memo(FieldDisplay) as typeof FieldDisplay;
